import { createSlice } from '@reduxjs/toolkit'
import { type RootState } from '../store'

interface OnboardingUiState {
  dismissOnboardingConfirmOpen: boolean
  onboardingCompletedOpen: boolean
}

const initialState: OnboardingUiState = {
  dismissOnboardingConfirmOpen: false,
  onboardingCompletedOpen: false,
}

const onboardingUiSlice = createSlice({
  name: 'onboardingUi',
  initialState,
  reducers: {
    openDismissOnboardingConfirm: (state) => {
      state.dismissOnboardingConfirmOpen = true
    },
    closeDismissOnboardingConfirm: (state) => {
      state.dismissOnboardingConfirmOpen = false
    },
    openOnboardingCompleted: (state) => {
      state.onboardingCompletedOpen = true
    },
    closeOnboardingCompleted: (state) => {
      state.onboardingCompletedOpen = false
    },
  },
})

export const { openDismissOnboardingConfirm, closeDismissOnboardingConfirm, openOnboardingCompleted, closeOnboardingCompleted } = onboardingUiSlice.actions

export const selectDismissOnboardingConfirmOpen = (state: RootState) => state.onboardingUi.dismissOnboardingConfirmOpen
export const selectOnboardingCompletedOpen = (state: RootState) => state.onboardingUi.onboardingCompletedOpen

export default onboardingUiSlice.reducer
